import {Component, Inject, OnInit} from '@angular/core';
import {SolicitacaoService} from 'app/service/solicitacao/solicitacao.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';

@Component({
  selector: 'app-grafico-componente-dialog',
  templateUrl: './grafico-componente-dialog.component.html',
  styleUrls: ['./grafico-componente-dialog.component.scss']
})
export class GraficoComponenteDialogComponent implements OnInit {

  nameSelected = "";
  obj;
  alocados;
  posicoesHorizontal = 0;
  posicoesVertical = 0;
  posicoesProfundidade = 0;
  quantidadePosicoes = 0;
  pixelsExibicao = "";
  espacamento = 2;
  tamanhoPosicao = 50;
  tamanhoPosicaoPixels = "50px";
  pixelsTotalLargura = "";
  pixelsTotaAltura = "";
  divs = [];
  qtdDivs = 0;
  itensExibicao = [];

  posicoesHorizontalLabel = "";
  posicoesVerticalLabel = "";
  posicoesProfundidadeLabel = "";
  numSolict;
  caixasPendenteRealocacaoResult;
  caixasDisponiveis;
  posicoeslivres = [];
  posicoesComponente = [];
  novasAlocacoes = []
  alocacoes = [];
  resultAlocacoes;
  alocacoesResult;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  loading = false;
  caixasAlocadasResult;
  solicitacaoResult;
  allCaixas;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private service: SolicitacaoService,
              public dialogRef: MatDialogRef<GraficoComponenteDialogComponent>, private _snackBar: MatSnackBar) {
    this.obj = data.componente;
  }

  ngOnInit() {

    this.nameSelected = this.obj.nome;

    this.alocacoesExistentes(this.obj);

    if (this.obj.isAlocacaoRecipiente) {
      this.service.listarAlocacao(this.obj.id).subscribe(data => {
        this.alocados = data;
        console.log(data)
        /*
        this.posicoesHorizontalM = 0;
        this.posicoesVerticalM = 0;
        this.divsM = [];
        this.divsParidadeM = [];
        */

        this.posicoesHorizontal = this.obj.qtdComponenteAlocavel.qtdHorizontal;
        this.posicoesVertical = this.obj.qtdComponenteAlocavel.qtdVertical;
        this.posicoesProfundidade = this.obj.qtdComponenteAlocavel.qtdProfundidade;

        this.posicoesHorizontalLabel = this.obj.qtdComponenteAlocavel.qtdHorizontal;
        this.posicoesVertical = this.obj.qtdComponenteAlocavel.qtdVertical;
        this.posicoesProfundidade = this.obj.qtdComponenteAlocavel.qtdProfundidade;

        this.calcularQuantidade();

      }, error => {
        this.alocados = [];
        console.log(error)
      })

    }
  }

  alocacoesExistentes(comp) {
    this.service.alocacoesComponente(comp.id).subscribe(data => {
      this.resultAlocacoes = data;
      this.alocacoes = this.resultAlocacoes;
      this.montarListaPosicoes(comp);
    })
  }

  calcularQuantidade() {


    this.quantidadePosicoes = (this.posicoesVertical * this.posicoesHorizontal) * this.posicoesProfundidade;

    this.pixelsExibicao = (this.tamanhoPosicao * this.posicoesProfundidade) + (((this.espacamento * 2) * (this.posicoesProfundidade - 1)) + (this.espacamento * 2)) + "px";

    console.log(this.pixelsExibicao)

    this.pixelsTotalLargura = (this.posicoesHorizontal * this.tamanhoPosicao) + (((this.espacamento * 2) * (this.posicoesHorizontal - 1)) + (this.espacamento * 2)) + "px";
    this.pixelsTotaAltura = (this.posicoesVertical * this.tamanhoPosicao) + (((this.espacamento * 2) * (this.posicoesVertical - 1)) + (this.espacamento * 2)) + "px";
    this.qtdDivs = this.quantidadePosicoes / this.posicoesProfundidade;
    //let linha = 1;
    let altura = 1;
    let posicaoLinha = 1;
    for (let i = 0; i < this.qtdDivs; i++) {
      let obj = {"posicao": posicaoLinha, "altura": altura};
      this.divs.push(obj);
      posicaoLinha++;
      if (posicaoLinha > this.posicoesHorizontal) {
        posicaoLinha = 1;
        altura++;
      }
    }

  }

  calcularCor(obj): string {
    let posicaoPai = 0;

    if (obj.altura == this.posicoesVertical) {
      posicaoPai = (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
    } else {
      let multiplicador = this.posicoesVertical - obj.altura;
      let t = (((this.posicoesHorizontal * multiplicador) * this.posicoesProfundidade) + (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1));

      posicaoPai = t;
    }
    let inicial = posicaoPai;
    let array = [];
    for (let i = 0; i < this.posicoesProfundidade; i++) {
      array.push(inicial)
      inicial++;
    }
    let qtdEncontrada = 0;
    array.forEach(element => {
      this.alocados.forEach(element2 => {
        if (element == element2.posicao) {
          qtdEncontrada++;
        }
      });
    });

    let color = "#17aa5d";
    if (qtdEncontrada == this.posicoesProfundidade) {
      color = "#9B111E";
    } else if (qtdEncontrada > 0 && qtdEncontrada < this.posicoesProfundidade) {
      color = "#EEAD2D";
    }

    return color;

  }

  detalharPosicao(obj) {

    if (this.itensExibicao.length > 0) {
      this.itensExibicao = [];
    } else {

      this.itensExibicao = [];
      console.log(obj)
      let posicaoPai = 0;

      if (obj.altura == this.posicoesVertical) {
        posicaoPai = (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
      } else {
        let multiplicador = this.posicoesVertical - obj.altura;
        let t = (((this.posicoesHorizontal * multiplicador) * this.posicoesProfundidade) + (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1));

        posicaoPai = t;
      }


      for (let i = 0; i < this.posicoesProfundidade; i++) {
        let encontrado = false;
        let cor = "#17aa5d";
        this.alocados.forEach(element2 => {
          if (posicaoPai == element2.posicao) {
            encontrado = true;
          }
        });
        if (encontrado) {
          cor = "#9B111E"
        }
        let item = {"posicao": posicaoPai, "cor": cor}
        this.itensExibicao.push(item);
        posicaoPai++;
      }

    }


  }

  calcularPosicao(obj) {

    if (obj.altura == this.posicoesVertical) {
      return (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
    } else {
      let multiplicador = this.posicoesVertical - obj.altura;
      let t = (((this.posicoesHorizontal * multiplicador) * this.posicoesProfundidade) + (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1));

      return t;
    }

  }

  buscarSolicitacao() {
    if (this.numSolict != null) {
      this.posicoeslivres = [];
      this.posicoesComponente = [];
      this.montarListaPosicoes(this.obj);
      this.service.getSolicitacao(this.numSolict).subscribe(data => {
        console.log(data);
        this.solicitacaoResult = data;
        this.allCaixas = this.solicitacaoResult.caixas.slice();
        this.verificarCaixaAlocadas();
      });
    }
  }

  verificarCaixaAlocadas() {
    this.service.caixasAlocadasSolicitacao(this.numSolict).subscribe(async (data) => {
      console.log(data);
      this.caixasAlocadasResult = await data;
      if (this.caixasAlocadasResult.length === 0) {
        this.caixasDisponiveis = this.allCaixas;
      } else {
        this.montarCaixasDisponiveis();
      }
    });
  }

  montarCaixasDisponiveis() {

    this.allCaixas.forEach(element => {
      if (!this.existAlocacao(element.rgCaixa)) {
        this.caixasDisponiveis.push(element)
      }
    });

    if (typeof this.caixasDisponiveis == "undefined" || this.caixasDisponiveis.length == 0) {
      this.openSnackBarError("Nenhuma caixa disponível encontrada! ")
    }
  }

  existAlocacao(rgCaixa) {
    let exist = false;
    this.caixasAlocadasResult.forEach(element => {
      if (element.rgRecipiente == rgCaixa) {
        exist = true;
      }
    });

    return exist;
  }


  alocarTodos() {
    let incluidos = [];
    this.caixasDisponiveis.forEach(element => {
      if (typeof this.posicoeslivres[0] != "undefined") {
        let posi = this.posicoeslivres[0]
        this.posicoesComponente[posi - 1] = "Posição " + posi + ": " + element.rgCaixa;
        this.posicoeslivres.splice(0, 1);
        let newAlc = {"posicao": posi, "rgRecipiente": element.rgCaixa}

        this.novasAlocacoes.push(newAlc);
        incluidos.push(element)
      } else {
        this.openSnackBarError("Posição não encontrada para caixa: " + element.rgCaixa);
      }
    });
    this.caixasDisponiveis = [];
  }

  incluirCaixaPosicao(caixa) {

    if (typeof this.posicoeslivres[0] != "undefined") {
      let posi = this.posicoeslivres[0]
      this.posicoesComponente[posi - 1] = "Posição " + posi + ": " + caixa.rgCaixa;
      this.posicoeslivres.splice(0, 1);
      let posicaoCaixa = this.caixasDisponiveis.indexOf(caixa)
      this.caixasDisponiveis.splice(posicaoCaixa, 1)
      let newAlc = {"posicao": posi, "rgRecipiente": caixa.rgCaixa}

      this.novasAlocacoes.push(newAlc);
    } else {
      alert("Prateleira sem posições o suficiente");
    }


  }

  montarListaPosicoes(comp) {
    if (comp.qtdComponenteAlocavel != null) {
      let qtdPosicoes = (comp.qtdComponenteAlocavel.qtdHorizontal * comp.qtdComponenteAlocavel.qtdVertical) * comp.qtdComponenteAlocavel.qtdProfundidade;

      for (let i = 1; i <= qtdPosicoes; i++) {
        let result = this.isPosicaoAlocada(i);
        if (result != "") {
          this.posicoesComponente.push("Posição " + i + ": " + result);
        } else {
          this.posicoeslivres.push(i)
          this.posicoesComponente.push("Posição " + i + ": " + "LIVRE");
        }
      }
    }

  }

  isPosicaoAlocada(posi) {
    let exist = "";
    this.alocacoes.forEach(element => {
      if (element.posicao == posi) {
        exist = element.rgRecipiente;
      }
    });

    return exist;
  }


  salvar() {

    if (this.obj.isAlocacaoRecipiente && this.novasAlocacoes.length > 0 && this.numSolict != null) {
      this.loading = true;
      let user = localStorage.getItem('APS_USERNAME');
      let body = {
        "componenteId": this.obj.id,
        "solicitacaoId": this.numSolict,
        "alocacoes": this.novasAlocacoes,
        "username": user
      }

      this.service.salvarMultiplasAlocacoesAndFinalizar(body).subscribe(data => {

        this.alocacoesResult = data;
        if (this.alocacoesResult.cod == 200) {
          if (this.alocacoesResult.result.length > 0) {
            this.openSnackBarSuccess("Total de " + this.alocacoesResult.result.length + " recipientes alocados !");
            this.dialogRef.close();
            this.loading = false;
          } else {
            this.loading = false;
          }

        } else {
          this.openSnackBarError(this.alocacoesResult.message);
          this.loading = false;
        }

      })

    }


  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/grafico-componente-dialog/grafico-componente-dialog.component.ts